var SubordinatesInBuController = /** @class */ (function () {
    /*@ngInject*/
    function SubordinatesInBuController(userService, alertsAndNotificationsService) {
        this.userService = userService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    SubordinatesInBuController.prototype.$onInit = function () {
        this.users = [];
        this.loading = true;
        this.getUsersInBu();
    };
    SubordinatesInBuController.prototype.getUsersInBu = function () {
        var _this = this;
        this.loading = true;
        this.userService.getSubordinatesByBu(this.userId, this.buId, function (data) {
            _this.users = data;
            _this._massageUsersData();
            _this.loading = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SubordinatesInBuController.prototype._massageUsersData = function () {
        this.users.forEach(function (user) {
            user.name = user.firstName + " " + user.lastName;
        });
    };
    return SubordinatesInBuController;
}());
SubordinatesInBuController.$inject = ['userService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './subordinates-in-bu.html';
import * as TEMPLATE from 'raw-loader!./subordinates-in-bu.html';
export var SubordinatedInBuComponent = {
    selector: 'subordinatesInBu',
    component: {
        bindings: {
            userId: '@',
            buId: '@'
        },
        controller: SubordinatesInBuController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addEditUser/subordinatesInBu/subordinates-in-bu.html'
    }
};
//# sourceMappingURL=subordinates-in-bu.component.js.map